module.exports = __webpack_public_path__ + "img/nutriteev-white.e46e71b5.svg";